module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABmJLR0QA/wD/AP+gvaeTAAAA0ElEQVRYhe2WUQ6CMAyGP43hBpJ4FPFEcA9Fr6cPXkC4Br50YQ4D0rnBw/6kadJ067empECSn3KxRbQH7sATOCxVvBOLCuEWjwqRAw8paHznxILOROUUMgA2WBUSAKCkf6UBQGJl6OKubACVtn8CCQKQATeg5XPap2TnNkAtd83WleGn5gKMxWy7aAAaOXwcyZnqSkHfidn6peXeOasewgSQAKJo53l+4wuweAcSwKoBWvGFx/0n8aplVPN9tWrsrAHIBMKsZY29pLjqhyQpit4MhGb+oJ9IggAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/routes/SuccessPayment/assets/icons8-share-rounded-32.png
// module id = 1554
// module chunks = 9